<template>
  <div>
    <!-- 通用抽奖开始-->
    <div class="actModules">
      <h3 class="actModules_title">{{modulesTitle}}</h3>
      <p class="actModules_descripe" v-html="modulesRules"></p>
      <ul class="actInvite_Wrap">
        <li class="actInvite_list" v-for="(inviteLis, index) in inviteList" :key="index">
          <img :src="inviteLis.img">
        </li>
      </ul>
      <div class="actModules_btnWrap">
        <div class="actModules_btnItems" v-for="(btnItem, index) in btnInfo" :key="index">
          <p class="actModules_btnDescript">{{btnItem.btnDesc}}</p>
          <a href="javascript:;" class="actModules_btn">{{btnItem.btnName}}</a>
        </div>
      </div>
      <div class="actLoterrt_time">
        {{lotteryNumLabel}}
        <span>{{lotteryNum}}</span>
      </div>
      <div class="lottery" id="lotterycontent2">
        <img :src="bgImg">
      </div>
    </div>
    <!-- 通用抽奖结束-->
  </div>
</template>

<script>
export default {
	name: 'pc-loterryTwo',
	actConfig: {
		labels: { // 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			bgImg: '背景图片',
			modulesRules: '规则描述',
			lotteryNumLabel: '抽奖次数描述',
			btnInfo: '功能按钮',
			btnDesc: '按钮功能描述',
			action: '动作',
			style: '按钮样式',
			btnName: '按钮文案',
			lotteryBtnInfo: '抽奖动作',
			giftIdList: '礼包ID列，逗号隔开'
		},
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字',
		},
		modulesRules: {
			type: String,
			default: '活动规则：自定义文案',
		},
		btnInfo: {
			type: Array,
			default: function () {
				return [
					{
						btnDesc: '规则规则规则规则规则规则规则规则规则规则',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
						},
						btnName: '功能按钮',
						style: ''
					},
					{
						btnDesc: '规则规则规则规则规则规则规则规则规则规则',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
						},
						btnName: '功能按钮',
						style: ''
					}
				]
			},
		},
		lotteryBtnInfo: {
			type: Array,
			default: function () {
				return [
					{
						action: {
							class: 'action',
							type: 'no', // ams link alert
							title: '抽奖按钮'
						},
					}
				]
			},
		},
		lotteryNumLabel: {
			type: String,
			default: '剩余抽奖次数',
		},
		bgImg: {
			type: String,
			default: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/loterry.png',
		},
		giftIdList: {
			type: String,
			default: '0,0,0,0,0,0,0,0'
		}
	},
	data () {
		return {
			inviteList: [
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' },
				{ img: 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/actInvite_list.png' }
			],
			lotteryNum: '0',
			lotteryHandle: null,
			i_flow_id: 0,
			gift_list: ['aaa', 'bbb', 'ccc', 'ddd', 'eee', 'fff', 'ggg', 'hhh'],
			giftstr: ''
		};
	},
	mounted () {
		this.lotteryHandle = new window.Lottery({
			'lighturl': 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/loterry-light.png',
			'starturl': 'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/loterry-start.png',
			'total': 8,
			'width': 900,
			'height': 900,
			'sbtnx': 305,
			'sbtny': 305,
			'sbtnw': 290,
			'sbtnh': 290,
			'boxw': 290,
			'boxh': 290,
			'position': '0_0,305_0,610_0,610_305,610_610,305_610,0_610,0_305,0_0',
			'contentId': 'lotterycontent2',
			'onClickRollEvent': this.callJsToStart.bind(this),
			'onCompleteRollEvent': this.callJsToComplete.bind(this)
		})
	},
	updated () {
		this.gift_list = this.giftIdList.split(',')
	},
	methods: {
		callJsToStart () {
			this.lotteryHandle.reset();
			this.$doAction('ams', this.loterryId)
				.then(({ sPackageName, iPackageId, ...other }) => {
					console.log(this, this.$doAction);
					let lid;
					this.giftstr = '恭喜您获得了 ' + sPackageName + ' !请您注意查收！';
					for (let i = 0; i < this.gift_list.length; i++) {
						if (this.gift_list[i] === iPackageId) {
							lid = i
							break
						}
					}
					if (this.lotteryHandle) this.lotteryHandle.stopRoll(lid);
				}).catch((e) => {
					console.log(e)
					alert(e.sMsg)
				})
		},
		callJsToComplete () {
			alert(this.giftstr)
		},
		invite () {
			console.log(this.inviteList.length)
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/common.scss";

.lottery {
  position: relative;
  width: 900px;
  height: 900px;
  margin: 20px auto;
}
.actModules_btnItems {
  @extend %inline-block;
  margin: 0 40px;
}

.actLoterrt_time {
  font-size: 24px;
  color: #4a4a4a;
  text-align: center;
  margin-top: 83px;
}

.actInvite_Wrap {
  font-size: 0;
  text-align: center;
  margin: 40px 0;
}

.actModules_btnDescript {
  font-size: 24px;
  color: #4a4a4a;
  text-align: center;
  margin-bottom: 10px;
}

.actInvite_list {
  width: 140px;
  height: 140px;
  overflow: hidden;
  @extend %inline-block;
  @include border-radius();
  margin: 0 21px;

  img {
    width: 100%;
    height: 100%;
  }
}

.actInvite_boxWrap {
  width: 1000px;
  margin: 90px auto 0;
}

.actInvite_boxTitle {
  font-size: 24px;
  color: #4a4a4a;
  margin-bottom: 10px;
}

.actInvite_boxContent {
  background: #d8d8d8;
  padding: 40px 28px;
}

.actInvite_boxContent {
  @extend %clearfix;
}

.actInvite_boxImg {
  @extend %left;
}

.actInvite_boxImg {
  width: 690px;
  height: 250px;
}

.actInvite_boxBtnWrap {
  width: 230px;
  height: 250px;
  @extend %relative;
  @extend %right;
}

.actInvite_boxBtn {
  width: 230px;
  height: 70px;
  line-height: 70px;
  font-size: 28px;
  color: #4a4a4a;
  @extend %block;
  text-align: center;
  background: #e27f7f;
  @extend %absolute;
  left: 50%;
  top: 50%;
  margin-left: -115px;
  margin-top: -35px;
}

.actInvite_boxList {
  width: 1000px;

  & + .actInvite_boxList {
    margin-top: 66px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/pc/templates/lottery/x-lottery-two.vue